<template>
  <v-container class="pa-0">    
    <v-row class="row">
      <v-col cols="12">        
        <upload-media :accept="'video/*|image/*'" @change="mediaChanged" :listMedia="media"></upload-media>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import UploadMedia from './UploadMedia';
export default {
  name: 'StoryForm',
  data() {
    return {
      media: []
    };
  },
  components: {
    UploadMedia
  },
  props: {
    post: Object
  },
  watch: {
    post(oval, val) {
      this.media = val.media
    }
  },
  mounted() {
    console.log('Media List', this.media);
  },
  methods: {
    mediaChanged(media) {
      this.$emit('media-changed', media);
    }
  }
};
</script>



// WEBPACK FOOTER //
// StoryForm.vue?9392da08